import axios from 'axios'
import KeycloakService from '../utils/keycloakService'
import {
  BackLogOrders,
  CurrentOrders,
  getAllLabDepartmentsEndpoint,
  UpdateLablocation,
} from '../features/bedManagement/endpoints/EndPoints'
import { returnStatus } from '../features/lms/utils'
import {
  CREATE_TESTCODES_ENDPOINT,
  ENABLED,
  FILE_UPLOAD_ENDPOINT,
  GET_ALL_DEVICE_MODELS_ENDPOINT,
  GET_ALL_PARAMETERS_ENDPOINT,
  GET_TESTCODES_BY_DEVICE_ID_ENDPOINT,
  LAB_DEVICE_ENDPOINT,
  LABS_PROJECT_ID,
  UPLOAD,
} from '../utils/constants'
import { toast } from 'react-toastify'
import { startSxpProxy } from '../utils/api'
import { lmsIntent } from './constants'
import { locErrorMsg } from '../features/lms/constants'

export const fetchActiveBacklogOrders = async (
  selectedDate: string,
  source: string,
  activeTab: string
) => {
  const start = `${selectedDate}T00:00:00`
  const nextDay = new Date(selectedDate)
  nextDay?.setDate(nextDay?.getDate() + 1)
  const end = `${nextDay?.toISOString()?.split('T')[0]}T00:00:00`

  const token = KeycloakService?.getToken()
  try {
    const response = await axios?.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${BackLogOrders}`,
      {
        unitLike: `%${source}%`,
        teststatus: returnStatus(activeTab),
        _start: start,
        _end: end,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      data: response?.data,
      success: true,
    }
  } catch {
    return {
      data: null,
      success: false,
    }
  }
}
export const activeFetchBacklogOrders = async (
  source: any,
  activeTab: any,
  selectedDate: string
) => {
  const nextDate = new Date(selectedDate)
  nextDate?.setDate(nextDate?.getDate() + 1)
  const nextDateString = nextDate?.toISOString()?.split('T')[0]
  const token = KeycloakService?.getToken()
  try {
    const response = await axios?.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CurrentOrders}`,
      {
        unitLike: `%${source}%`,
        teststatus: returnStatus(activeTab),
        _gte: selectedDate,
        _lte: nextDateString,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      data: response?.data,
      success: true,
    }
  } catch {
    return {
      data: null,
      success: false,
    }
  }
}

export const getAllLabDevices = async (
  offset: number,
  pageSize: number,
  param: string,
  value: string
) => {
  const token = KeycloakService?.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}?offset=${offset}&limit=${pageSize}&${param}=${value}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const createDevice = async (values: any) => {
  const token = KeycloakService?.getToken()
  try {
    delete values?.id
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const updateDeviceById = async (values: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}/${values?.id}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getDeviceById = async (selectedLMSItemId: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}/${selectedLMSItemId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const deletedevice = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}/${data?.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const toggleEnable = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}/${data?.id}/${ENABLED}`,
      { enabled: !data?.enabled },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const addParameterMapping = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CREATE_TESTCODES_ENDPOINT}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getTestCodesByModelId = async (
  data: any,
  offset: number,
  pageSize: number
) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_TESTCODES_BY_DEVICE_ID_ENDPOINT}${data}?offset=${offset}&limit=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getTestCodesById = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CREATE_TESTCODES_ENDPOINT}/${data}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        message: response?.data?.message,
        data: [],
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const updateTestCode = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CREATE_TESTCODES_ENDPOINT}/${data?.id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        data: [],
        success: false,
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      data: [],
      success: false,
      message: error?.response?.data?.message,
    }
  }
}

export const uploadTestCodeFile = async (data: any, id: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${FILE_UPLOAD_ENDPOINT}${id}${UPLOAD}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const deleteTestCode = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CREATE_TESTCODES_ENDPOINT}/${data?.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getAllLabDepartments = async () => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${getAllLabDepartmentsEndpoint}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      success: true,
      data: response?.data,
      message: 'Fetched Lab Departments',
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getAllLabDeviceModels = async (
  offset: number,
  pageSize: number
) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}?offset=${offset}&limit=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getDeviceModelById = async (Id: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}/${Id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        message: response?.data?.message,
        data: [],
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const createDeviceModel = async (values: any) => {
  const token = KeycloakService?.getToken()
  try {
    delete values?.id
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const updateDeviceModelById = async (values: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}/${values?.id}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const deleteDeviceModel = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}/${data?.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const healthScoreAPI = async (data: any) => {
  const token = KeycloakService?.getToken()
  const response = await axios.post(
    `${process.env.REACT_APP_API_GATEWAY_URL}api/healthindex-score/compute`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  )
  return response?.data
}

export const getAllParameters = async () => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_PARAMETERS_ENDPOINT}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.lab_test) {
      return {
        success: true,
        data: response?.data,
      }
    } else {
      return {
        success: false,
        data: [],
        message: 'Error while fetching THOP parameters',
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: 'Error while fetching THOP parameters',
    }
  }
}

export const enableDeviceModel = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}/${data?.id}/${ENABLED}`,
      {
        enabled: !data?.enabled,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const UpdateLabInvoice = async (
  origin: any,
  products: any,
  documentId: number,
  orderRef: any
) => {
  const state = {
    origin,
    payload: {
      ...(origin !== 'B2B' && { document_type: 'invoice' }),
      ...(origin == 'B2B'
        ? { order_id: documentId }
        : { document_id: documentId }),
      products_list: products,
      order_ref: orderRef,
    },
  }

  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.updateLabOrderInvoice,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const CreateLabInvoice = async (
  selectedLocationId: any,
  origin: string,
  products: any,
  patientIdentifier: number,
  reqOdooId: string,
  reqDoctorRef: string
) => {
  const state = {
    selectedLocationId,
    origin,
    products,
    patient_identifier: patientIdentifier,
    reqOdooId: reqOdooId,
    doctor_thop_id: reqDoctorRef,
  }
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.createLabInvoice,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
export const getAllPanelsApi = async (): Promise<any[]> => {
  try {
    const state = {}
    const data = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.getAllPanelsApi,
      state
    )
    const panelData: any[] = data?.data?.panel ?? []
    const tests = panelData.map((test: any) => ({
      label: test?.name,
      value: String(test?.id),
      panel: {
        name: test?.name,
        description: test?.description,
        id: test?.id,
        lab_tests: test?.lab_tests,
        sampleId: parseInt(test?.sample?.value),
        sampleName: test?.sample?.name,
      },
    }))
    return tests
  } catch (error) {
    console.error(error)
    return []
  }
}

export const getLabInvoices = async (
  state = {
    ref_prefix: 'LAB',
    doc_type: 'invoice',
  }
) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.getOrderInvoices,
      state
    )
    return response
  } catch (error) {
    console.error('Error fetching lab invoices:', error)
    throw error
  }
}

export const createdOrderEvent = async (state: any) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.createOrderEvent,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getOdooProductPrice = async (state: any) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.getTestPriceFromOdoo,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const updateLabOrderPU = async (payload: any) => {
  const token = KeycloakService?.getToken()

  try {
    const data = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UpdateLablocation}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      data: data.data,
      success: true,
      message: locErrorMsg?.AsignedLoc,
    }
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || 'Update failed'
    toast.error(message)

    return {
      data: null,
      success: false,
      message,
    }
  }
}
export const cancelLabOrder = async (origin: any, labOrderId: any) => {
  const state = {
    origin,
    labOrderId,
  }
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.CancelLabOrder,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
